import { baseUrl, translate } from "@kaltura/mediaspace-shared-utils";
import { Tooltip, useMenu } from "@kaltura/ds-react-components";
import { AddNewMenuButton } from "./AddNewMenuButton";
import { Add24Icon } from "@kaltura/ds-react-icons";
import { AddNewMenu as AddNewMenuBase } from "@kaltura/mediaspace-shared-add-new";
import { ButtonClickAnalyticsType, KmsTypeAddNewMenuSection } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

export interface AddNewMenuProps {
    createAsLogin?: boolean;
    sections?: KmsTypeAddNewMenuSection[];
    /**
     * prevent scroll bar appreaing, displacing absolutly positioned items.
     * used on legacy kms header.
     */
    disableScrollLock?: boolean;
}

/**
 *  `Add New` menu as used in the site header:
 *   - menu button.
 *   - menu positioning.
 */
export function AddNewMenu(props: AddNewMenuProps) {
    const { createAsLogin = false, sections, ...rest } = props;

    const sendButtonAnalytics = useButtonAnalytics();

    const { buttonProps, menuProps, close } = useMenu({
        menuId: "addNewMenu",
        onOpen: () => sendAnalytics("Create - Header", ButtonClickAnalyticsType.MENU),
    });

    const sendAnalytics = (actionName: string, buttonType: ButtonClickAnalyticsType) => {
        sendButtonAnalytics(actionName, buttonType);
    };

    return (
        <>
            {createAsLogin && (
                <Tooltip title={translate("Login to create new media")} placement={"bottom"}>
                    <AddNewMenuButton
                        startIcon={<Add24Icon />}
                        component="a"
                        href={baseUrl + "/user/login"}
                        aria-label={translate("Login to create new media")}
                        role="link"
                        onClick={() => sendAnalytics("Create - Header", ButtonClickAnalyticsType.MENU)}
                    >
                        {translate("Create")}
                    </AddNewMenuButton>
                </Tooltip>
            )}
            {!createAsLogin && sections && sections.length > 0 && (
                <>
                    <AddNewMenuButton
                        {...buttonProps}
                        id={"addNewMenuToggleBtn"}
                        aria-label={translate("Create")}
                        startIcon={<Add24Icon />}
                    >
                        {translate("Create")}
                    </AddNewMenuButton>
                    <AddNewMenuBase
                        {...menuProps}
                        sections={sections}
                        {...rest}
                        aria-labelledby={"addNewMenuToggleBtn"}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                        className="add-newMenuToggleBtn"
                        closeMenu={close}
                    />
                </>
            )}
        </>
    );
}

export default AddNewMenu;
